module.exports = __webpack_public_path__ + "img/Faculty-candids-Menjie-Di-Fall-2014-JM_40.c39d356b.webp";